<template>
  <form
    class="template-form"
    v-on:submit.prevent="onSubmit"
  >
    <autocomplete-input
      label="Категория"
      item-value="id"
      item-text="name"
      v-bind:items=treatmentsCategories
      v-bind:violations="categoryInputErrors"
      v-model="categoryId"
    />
    <picker-services
      v-bind:title="selectedPriceListName"
      v-bind:with-previous-button="true"
      v-bind:price-list-name="selectedPriceListName"
      v-bind:initial-category-list="selectedCategories"
      v-bind:shown-accordion="shownAccordionServices"
      v-bind:selected-services-ids="selectedServicesIds"
      v-model="shownAddingServicesFromPriceModal"
      v-on:add-service="onAddingPriceService"
      v-on:on-previous-button="onPreviousButton"
    >
      <template v-slot:header>
        <input-text-search
          class="patient-visits__services__search-input"
          placeholder="Услуга, код клиники"
          v-bind:is-loading="isAwaitLoadingMatchedServices"
          v-bind:violations="searchInputViolations"
          v-model="searchQuery"
        />
      </template>
      <template
        v-slot:default="{
          groupedList,
          emitAddService,
          selectedServices,
        }">
        <matched-service-list
          v-bind:show-price-name="false"
          v-bind:grouped-list="groupedList"
          v-bind:matched-service-list="matchedServiceList"
          v-bind:selectedServices="selectedServices"
          v-bind:selected-services-ids="selectedServicesIds"
          v-on:select-service="emitAddService"
        />
      </template>
    </picker-services>
    <modal-dialog
      title="Выберите прайс лист"
      max-width="750"
      v-model="shownPriceListsSelectModal"
      v-on:on-click-outside="shownPriceListsSelectModal = false"
      with-cross
    >
      <price-lists-select-modal
        v-bind:price-lists=priceLists
        v-on:select-price-list="onSelectedPriceList"
      />
    </modal-dialog>
    <input-text
      v-bind:maxlength="200"
      v-model.trim="name"
      name="name"
      required="required"
      title="Название шаблона"
      show-counter
      v-bind:violations="nameInputErrors"
    />
    <div
      v-if="hasStages"
      class="template-form__stages"
    >
      <div
        class="template-form__stage"
        v-for="stage in stages"
        v-bind:key="`stage-${stage.index}`"
      >
        <div class="template-form__stage__title">
          <input-text
            class="template-form__stage__title__input"
            title="Название Этапа"
            v-bind:maxlength="100"
            v-bind:violations="stageNameInputErrors(stage.index)"
            v-bind:name='`stage.${stage.index}.name`'
            v-model.trim="stage.name"
            show-counter
          />
          <button
            class="template-form__service-remove"
            type="button"
            v-on:click="removeStage(stage.index)"
          >Удалить</button>
        </div>
        <fieldset
          class="template-form__service template-form__stage__service"
          v-for="{
            name, code, count, parts, index, price, teeth, getFinalPrice,
          } in stage.services"
          v-bind:key="index"
        >
          <hr class="template-form__service__divider">
          <input
            type="hidden"
            v-bind:name="`services.${index}.price`"
            v-bind:value="price" />
          <input
            v-for="(tooth, toothIndex) in teeth"
            v-bind:key="tooth"
            v-bind:name="`services.${index}.teeth.${toothIndex}`"
            v-bind:value="tooth"
            type="hidden" />
          <input
            v-for="(part, partIndex) in parts"
            v-bind:key="part.value"
            v-bind:name="`services.${index}.dental_parts.${partIndex}`"
            v-bind:value="part.value"
            type="hidden" />
          <div class="template-form__service__row">
            <span class="template-form__service-title">Услуга №{{ index + 1 }}</span>
            <button
              class="template-form__service-remove"
              type="button"
              v-on:click="removeStageService(stage.index, index)"
            >Удалить</button>
          </div>
          <input v-bind:name="`services.${index}.code`" type="hidden" v-bind:value="code">
          <input-text
            v-bind:disabled="true"
            title="Название услуги"
            v-bind:value="name"
          />
          <div>
            <popover-menu>
              <template v-slot:trigger="{ listenerObject }">
                <div class="template-form__service__row">
                  <label
                    class="template-form__service-label"
                    v-bind:for="`service-${index}-teeth`"
                  >Выберите зубы</label>
                  <button
                    class="template-form__tooth-change"
                    title="Нажмите для выбора"
                    type="button"
                    v-bind:class="{ empty: parts.length + teeth.length === 0 }"
                    v-bind:id="`service-${index}-teeth`"
                    v-on="listenerObject"
                  >{{ getTeethText(teeth, parts) }}</button>
                </div>
              </template>
              <teeth-select-popup
                v-on:submit="onChangeTeeth(index, ...arguments, stage.index)"
                v-bind:initial-dental-parts="parts"
                v-bind:initial-selected="teeth" />
            </popover-menu>
          </div>
          <input-number
            allowed-null
            required="required"
            title="Введите количество"
            v-bind:name="`services.${index}.count`"
            v-bind:value="count"
            v-bind:min="1"
            v-on:focus="onFocusCountInput(index, count)"
            v-on:input="onChangeCount(index, $event, stage.index)" />
          <div class="template-form__prices">
            <input-layout title="Цена">
              <the-rub
                currency="тнг"
                v-bind:show-kop="$options.SHOW_KOP_AUTO"
                v-bind:kop="price"
              />
            </input-layout>
            <input-layout title="Итого">
              <the-rub
                currency="тнг"
                v-bind:show-kop="$options.SHOW_KOP_AUTO"
                v-bind:kop="getFinalPrice()"
              />
            </input-layout>
          </div>
        </fieldset>
        <button
          class="template-form__service-add"
          type="button"
          v-on:click="addBlankService(stage.index)"
        >Добавить услугу</button>
      </div>
    </div>
    <div
      v-else-if="services.length"
      class="template-form__services"
    >
      <fieldset
        class="template-form__service"
        v-for="{
          name, code, count, parts, index, price, teeth, getFinalPrice,
        } in services"
        v-bind:key="index"
      >
        <input
          type="hidden"
          v-bind:name="`services.${index}.price`"
          v-bind:value="price" />
        <input
          v-for="(tooth, toothIndex) in teeth"
          v-bind:key="tooth"
          v-bind:name="`services.${index}.teeth.${toothIndex}`"
          v-bind:value="tooth"
          type="hidden" />
        <input
          v-for="(part, partIndex) in parts"
          v-bind:key="part.value"
          v-bind:name="`services.${index}.dental_parts.${partIndex}`"
          v-bind:value="part.value"
          type="hidden" />
        <div class="template-form__service__row">
          <span class="template-form__service-title">Услуга №{{ index + 1 }}</span>
          <button
            class="template-form__service-remove"
            type="button"
            v-on:click="removeService(index)"
          >Удалить</button>
        </div>
        <input v-bind:name="`services.${index}.code`" type="hidden" v-bind:value="code">
        <input-text
          v-bind:disabled="true"
          title="Название услуги"
          v-bind:value="name"
        />
        <div>
          <popover-menu>
            <template v-slot:trigger="{ listenerObject }">
              <div class="template-form__service__row">
                <label
                  class="template-form__service-label"
                  v-bind:for="`service-${index}-teeth`"
                >Выберите зубы</label>
                <button
                  class="template-form__tooth-change"
                  title="Нажмите для выбора"
                  type="button"
                  v-bind:class="{ empty: parts.length + teeth.length === 0 }"
                  v-bind:id="`service-${index}-teeth`"
                  v-on="listenerObject"
                >{{ getTeethText(teeth, parts) }}</button>
              </div>
            </template>
            <teeth-select-popup
              v-on:submit="onChangeTeeth(index, ...arguments)"
              v-bind:initial-dental-parts="parts"
              v-bind:initial-selected="teeth" />
          </popover-menu>
        </div>
        <input-number
          allowed-null
          required="required"
          title="Введите количество"
          v-bind:name="`services.${index}.count`"
          v-bind:value="count"
          v-bind:min="1"
          v-on:focus="onFocusCountInput(index, count)"
          v-on:input="onChangeCount(index, $event)" />
        <div class="template-form__prices">
          <input-layout title="Цена">
            <the-rub
              currency="тнг"
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
              v-bind:kop="price"
            />
          </input-layout>
          <input-layout title="Итого">
            <the-rub
              currency="тнг"
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
              v-bind:kop="getFinalPrice()"
            />
          </input-layout>
        </div>
      </fieldset>
    </div>
    <div class="template-form__service-buttons">
      <button
        class="template-form__service-add"
        type="button"
        v-on:click="addBlankStage"
      >Добавить этап</button>
      <button
        v-if='!hasStages'
        class="template-form__service-add"
        type="button"
        v-on:click="addBlankService()"
      >Добавить услугу</button>
    </div>
    <input-checkbox
      name="is_print_logo"
      title="Печатать логотип"
      v-model="isPrintLogo"
    />
    <div class="template-form__buttons">
      <button
        class="template-form__button-cancel"
        type="button"
        v-on:click.prevent="onCancel">
        Отмена
      </button>
      <button type="submit" class="template-form__button-save">
        Сохранить
      </button>
    </div>
  </form>
</template>
<script>
import { List } from 'monet';
import formMixin from '@/mixins/formMixin';
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputLayout from '@/components/InputLayout.vue';
import InputNumber from '@/components/InputNumber.vue';
import InputText from '@/components/InputText.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import TeethSelectPopup from '@/components/TeethSelectPopup.vue';
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import PickerServices from '@/components/PickerServices.vue';
import MatchedServiceList from '@/components/MatchedServiceList.vue';
import addingServicesFromPriceMixin from '@/mixins/addingServicesFromPriceMixin';
import PriceListsSelectModal from '@/components/PriceListsSelectModal.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import { TemplatePlanRequest } from '@/storage/gateways/PlanGateway';
import AutocompleteInput from '@/components/AutocompleteInput.vue';

/**
 * @description Наименование события отмены.
 * @type {string}
 */
const NAME_EVENT_ON_CANCEL = 'cancel';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Услуга плана.
 * @param {number} index  Индекс.
 * @param {string} name   Название услуги.
 * @param {string} code   Код услуги.
 * @param {number} count  Количество единиц.
 * @param {any[]}  parts  Стоматологические части.
 * @param {number} price  Цена.
 * @param {int[]}  teeth  Номера зубов.
 * @param {string} units  Единица измерения.
 * @constructor
 */
export function Service(
  index,
  name = '',
  code = '',
  count = 1,
  parts = [],
  price = 0,
  teeth = [],
  units = '',
) {
  this.code = code;
  this.name = name;
  this.count = count;
  this.parts = parts;
  this.index = index;
  this.price = price;
  this.teeth = teeth;
  this.units = units;
  const finalPrice = count * price;
  this.getFinalPrice = () => finalPrice;
  this.setPricedService = (newCode, newPrice, newUnits) => new this
    .constructor(
      this.index,
      this.name,
      newCode,
      this.count,
      this.parts,
      newPrice,
      this.teeth,
      newUnits,
    );
  this.setCount = (value) => new this
    .constructor(
      this.index,
      this.name,
      this.code,
      value,
      this.parts,
      this.price,
      this.teeth,
      this.units,
    );
  this.setTeeth = (newTeeth, newParts) => new this
    .constructor(
      this.index,
      this.name,
      this.code,
      this.count,
      newParts,
      this.price,
      newTeeth,
      this.units,
    );
  this.setUnits = (value) => new this
    .constructor(
      this.index,
      this.name,
      this.code,
      this.count,
      this.parts,
      this.price,
      this.teeth,
      value,
    );
}

/**
 * @description Этап
 * @param {number} index
 * @param {number|null} code
 * @param {string} name
 * @param {Service[]} services
 * @constructor
 */
export function Stage(
  index,
  code = null,
  name = '',
  services = [],
) {
  this.code = code;
  this.index = index;
  this.name = name;
  this.services = services;

  this.updateServiceByIndex = (updater) => ((indexService) => this.services.map(
    (service) => (service.index === indexService ? updater(service) : service),
  ));
}

/**
 * @description Форма шаблона для плана лечения.
 * @type {Vue}
 */
export default {
  components: {
    AutocompleteInput,
    ModalDialog,
    PriceListsSelectModal,
    MatchedServiceList,
    PickerServices,
    InputTextSearch,
    InputCheckbox,
    InputLayout,
    InputNumber,
    InputText,
    PopoverMenu,
    TeethSelectPopup,
    TheRub,
  },
  SHOW_KOP_AUTO,
  computed: {
    nameInputErrors: resolveInputErrors('name'),
    categoryInputErrors: resolveInputErrors('category-id'),
    stageNameInputErrors() {
      return (stageIndex) => {
        const key = `stage-${stageIndex}-name`;
        return key in this.inputErrors ? this.inputErrors[key] : [];
      };
    },
    /**
     * @description Имеются этапы.
     * @returns {boolean}
     */
    hasStages() {
      return this.stages.length > 0;
    },
    selectedServicesIds() {
      if (this.selectedStageIndex !== null) {
        return this.stages[this.selectedStageIndex].services.map((service) => service.code);
      }
      return this.services.map((service) => service.code);
    },
  },
  data() {
    const cloneStage = (stage) => new Stage(
      stage.index,
      stage.code,
      stage.name,
      stage.services.slice(),
    );
    const stages = this.initialStages.map(cloneStage);
    return {
      /**
       * @description Id Категории.
       * @type {string}
       */
      categoryId: this.initialCategoryId,
      /**
       * @description Печатать логотип.
       * @type {boolean}
       */
      isPrintLogo: this.initialIsPrintLogo,
      /**
       * @description Название шаблона.
       * @type {string}
       */
      name: this.initialName,
      /**
       * @description Индекс выбранного этапа.
       * @type {number|null}
       */
      selectedStageIndex: null,
      /**
       * @description Услуги плана лечения.
       * @type {Array<Service>}
       */
      services: this.initialServices.slice(),
      /**
       * @description Этапы плана лечения.
       * @type {Array<Stage>}
       */
      stages,
    };
  },
  methods: {
    /**
     * @description Отменить.
     * @returns {void}
     */
    onCancel() {
      this.$emit(NAME_EVENT_ON_CANCEL);
    },
    getTeethText(teeth, parts) {
      const titles = parts.map(({ title }) => title);
      return [...teeth, ...titles].join(', ');
    },
    /**
     * @description Обработать добавление пустой услуги к шаблону.
     * @returns {void}
     */
    addBlankService(stageIndex = null) {
      this.selectedStageIndex = stageIndex;
      const isOnlyOnePriceList = this.priceLists.length === 1;
      if (isOnlyOnePriceList) {
        const firstPriceList = this.priceLists[0];
        this.onSelectedPriceList(firstPriceList);
      } else {
        this.shownPriceListsSelectModal = true;
      }
    },
    /**
     * @description Добавить этап.
     * @returns {void}
     */
    addBlankStage() {
      const stageNumber = this.stages.length + 1;
      const addingStage = new Stage(
        this.stages.length,
        null,
        `Этап ${stageNumber}`,
        [],
      );
      if (!this.hasStages) {
        addingStage.services = this.services;
        this.services = [];
      }
      this.$set(this.stages, this.stages.length, addingStage);
    },
    /**
     * @description Создать запрос.
     * @returns {TemplatePlanRequest}
     */
    makeRequest() {
      return new TemplatePlanRequest(
        this.name,
        this.isPrintLogo,
        this.services,
        this.stages,
        this.categoryId,
      );
    },
    /**
     * @description Обработать добавление услуги из прайса.
     * @param {Object} service Услуга.
     * @returns {void}
     */
    onAddingPriceService(service) {
      const addingService = new Service(
        this.services.length,
        service.name,
        service.id,
        1,
        [],
        service.cost,
        [],
        service.units,
      );
      if (this.selectedStageIndex !== null) {
        const index = this.stages[this.selectedStageIndex].services.findIndex(
          (item) => item.code === addingService.code,
        );
        addingService.index = this.stages[this.selectedStageIndex].services.length;
        if (index === -1) {
          this.stages[this.selectedStageIndex].services.push(addingService);
        } else {
          this.stages[this.selectedStageIndex].services.splice(index, 1);
        }
        return;
      }
      const index = this.services.findIndex(
        (item) => item.code === addingService.code,
      );
      if (index === -1) {
        this.services.push(addingService);
      } else {
        this.services.splice(index, 1);
      }
    },
    /**
     * @description Обработать изменение количества услуги.
     * @param {number} serviceIndex Индекс услуги.
     * @param {number} count        Количество.
     * @param stageIndex
     * @returns {void}
     */
    onChangeCount(serviceIndex, count, stageIndex = null) {
      const counter = Math.max(Number(count), 1);
      const updater = (service) => service.setCount(counter);
      if (stageIndex !== null) {
        this.stages[stageIndex].services = this
          .stages[stageIndex]
          .updateServiceByIndex(updater)(serviceIndex);
      } else {
        this.services = this.updateServiceByIndex(updater)(serviceIndex);
      }
    },
    /**
     * @description Обработать изменение зубов для услуги.
     * @param {number} serviceIndex Индекс услуги.
     * @param {int[]}  teeth        Номера зубов.
     * @param {any[]}  parts        Стоматологические части.
     * @param selectedGroup
     * @param {number|null} stageIndex Индекс этапа.
     * @returns {void}
     */
    onChangeTeeth(serviceIndex, teeth, parts, selectedGroup, stageIndex = null) {
      const updater = (service) => service.setTeeth(teeth, parts);
      if (stageIndex !== null) {
        this.stages[stageIndex].services = this
          .stages[stageIndex]
          .updateServiceByIndex(updater)(serviceIndex);
      } else {
        this.services = this.updateServiceByIndex(updater)(serviceIndex);
      }
    },
    /**
     * @description Обработать фокус на поле количества услуги.
     * @param {number} serviceIndex Индекс услуги.
     * @param {number} count        Количество.
     * @returns {void}
     */
    onFocusCountInput(serviceIndex, count) {
      if (count.toString().charAt(0) === '0') {
        this.onChangeCount(serviceIndex, '');
      }
    },
    /**
     * @description Обработать отправку данных шаблона.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit('submit', request);
    },
    /**
     * @description Удалить услугу плана.
     * @param {number} serviceIndex Индекс услуги.
     * @returns {void}
     */
    removeService(serviceIndex) {
      const exclude = (index) => (service) => service.index !== index;
      const reindex = (acc, service) => acc.cons(
        new Service(
          acc.size(),
          service.name,
          service.code,
          service.count,
          service.parts,
          service.price,
          service.teeth,
          service.units,
        ),
      );
      this.services = List
        .fromArray(this.services)
        .filter(exclude(serviceIndex))
        .foldLeft(List())(reindex)
        .reverse()
        .toArray();
    },
    /**
     * @description Удалить этап.
     * @param {number} stageIndex
     * @returns {void}
     */
    removeStage(stageIndex) {
      const exclude = (index) => (stage) => stage.index !== index;
      const reindex = (acc, stage) => acc.cons(
        new Stage(
          acc.size(),
          null,
          stage.name,
          stage.services,
        ),
      );
      this.selectedStageIndex = null;
      this.stages = List
        .fromArray(this.stages)
        .filter(exclude(stageIndex))
        .foldLeft(List())(reindex)
        .reverse()
        .toArray();
    },
    /**
     * @description Удалить услугу этапа.
     * @param {number} stageIndex
     * @param {number} serviceIndex
     * @return {void}
     */
    removeStageService(stageIndex, serviceIndex) {
      const exclude = (index) => (service) => service.index !== index;
      const reindex = (acc, service) => acc.cons(
        new Service(
          acc.size(),
          service.name,
          service.code,
          service.count,
          service.parts,
          service.price,
          service.teeth,
          service.units,
        ),
      );
      this.stages[stageIndex].services = List
        .fromArray(this.stages[stageIndex].services)
        .filter(exclude(serviceIndex))
        .foldLeft(List())(reindex)
        .reverse()
        .toArray();
    },
    /**
     * @description Получить обновление услуг плана по индексу.
     * @param {function(Service): Service} updater Обновление услуги.
     * @returns {function(Number): Service[]}
     */
    updateServiceByIndex(updater) {
      return (index) => this.services.map(
        (service) => (service.index === index ? updater(service) : service),
      );
    },
  },
  mixins: [
    formMixin,
    addingServicesFromPriceMixin,
  ],
  name: 'FormTreatmentPlanTemplate',
  props: {
    /**
     * @description Стоматологические услуги.
     * @type {{code: string, name: string}[]}
     */
    dentalServices: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Прайс-листы
     * @type {Object}
     */
    priceLists: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Исходное название шаблона.
     * @type {string}
     */
    initialName: {
      default: () => '',
      type: String,
    },
    /**
     * @description Исходные услуги плана лечения.
     * @type {Service[]}
     */
    initialServices: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Исходные услуги плана лечения.
     * @type {Array<Stage>}
     */
    initialStages: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Исходное значение Id категории.
     * @type {number|null}
     */
    initialCategoryId: {
      type: Number,
      required: false,
      default: () => null,
    },
    /**
     * @description Печатать логотип.
     * @type {boolean}
     */
    initialIsPrintLogo: { default: () => true, type: Boolean },
    /**
     * @description Единицы измерения услуги.
     * @type {string[]}
     */
    serviceUnits: { type: Array, required: true },
    /**
     * @description Ограничения нарушений.
     * @type {any}
     */
    inputErrors: { type: Object, required: true },
    /**
     * @description Категории шаблонов.
     * @type {Array}
     */
    treatmentsCategories: { type: Array, required: true },
  },
};
</script>
<style lang="scss">
@use "@/scss/buttons";
@use "@/scss/fields";
.template-form {
  border-radius: var(--block-border-radius);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 1rem;
  margin: 20px 0 0 0;
  &__stages {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  &__stage {
    display: grid;
    row-gap: 20px;
    background-color: var(--primary-background-color);
    border-radius: 10px;
    padding: 20px;
    border: 1px solid var(--border-color);
    &__title {
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: end;
      &__input {
        width: 100%;
      }
    }
  }
  &__services {
    display: grid;
    row-gap: 20px;
  }
  &__service {
    background-color: var(--primary-background-color);
    border: none;
    border-radius: var(--block-border-radius);
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0 32px;
    &-buttons {
      display: flex;
      gap: 10px;
      align-items: center
    }
    &-add {
      @include buttons.btn-transparent(12rem, 3rem, 1rem);
      @include buttons.btn-transparent-add(1rem);
    }
    &-label {
      @extend %field-label;
    }
    &-remove {
      @include buttons.btn-transparent-remove(1rem);
      margin-left: auto;
    }
    &-title {
      font-weight: 600;
    }
    &__row {
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
    }
    &__divider {
      margin-left: -52px;
      margin-right: -52px;
      width: calc(100% + 102px);
      border-top: 1px solid var(--border-color);
    }
  }
  &__prices {
    display: flex;
    gap: 1.5rem;
  }
  &__submit {
    @include buttons.btn-blue(12rem, 3rem, 1rem);
  }
  &__search-input {
    width: 100%;

  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    max-width: 438px;
    width: 100%;
    margin: 30px 0 0 auto;
  }
  &__button {
    &-cancel {
      @include buttons.btn-transparent(100%, 3rem, 1rem);
    }
    &-save {
      @include buttons.btn-blue(100%, 3rem, 1rem);
    }
  }
}
.template-form .template-form__tooth-change,
.template-form .template-form__service-remove {
  min-height: 2rem;
}
.template-form .template-form__tooth-change.empty {
  background: url("@/assets/img/tooth.svg") no-repeat;
  background-size: contain;
  height: 30px;
  width: 1rem;
}
@media screen and (max-width: 480px) {
  .template-form .template-form__actions {
    flex-direction: column;
  }
  .template-form .template-form__service-add {
    @include buttons.btn-transparent(100%, 3rem, 1rem);
  }
  .template-form .template-form__submit {
    @include buttons.btn-blue(100%, 3rem, 1rem);
  }
}
</style>
